const getters = {
    userType: state => state.user.userType,
    userId: state => state.user.userId,
    account: state => state.user.account,
    globalServiceCharge: state => state.app.globalServiceCharge,
    merchantId: state => state.app.merchantId
}

export default getters